export default function joinPaths(...paths: string[]): string {
    return paths.map((path) => path.replace(/(^\/+|\/+$)/g, '')).join('/');
}
